import { getCache } from './typeahead-cache';

export const hashCodeSearches = (
  response: Accelerate.SequencableCodeSearchResponse
) => {
  const { searchId } = response.meta;
  const { searchType } = response.codeQuery;
  return `${searchId}:${searchType}`;
};

export const hashProviderSearches = (
  response: Accelerate.SequencableProviderSearch
) => {
  const { searchType, providerType } = response.meta;
  return `${providerType}:${searchType}`;
};

export const searchCache = getCache<Accelerate.SequencableCodeSearchResponse>(
  'codeSearch',
  hashCodeSearches
);

export const providerSearchCache = getCache<
  Accelerate.SequencableProviderSearch
>('providerSearch', hashProviderSearches);
